import { render, staticRenderFns } from "./travailleurs.html?vue&type=template&id=23ef060f&scoped=true&external"
import script from "./travailleurs.js?vue&type=script&lang=js&external"
export * from "./travailleurs.js?vue&type=script&lang=js&external"
import style0 from "./travailleurs.scss?vue&type=style&index=0&id=23ef060f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef060f",
  null
  
)

export default component.exports